import React from 'react';
import cn from 'classnames';
import LinesEllipsis from 'react-lines-ellipsis';
import { Price } from 'swag-client-common/utils/price';
import { GoodieGiveawayProductQuantityInput } from '../goodie-giveaway-product-quantity-input';
import responsiveClasses from './goodie-giveaway-product-card.scss';
import fixedClasses from './goodie-giveaway-product-card-fixed.scss';
export const GoodieGiveawayProductCard = ({
  product,
  isFixed = false,
  quantity,
  onClick,
  onChange,
  ableToSelect = true,
  color
}) => {
  const {
    image,
    name,
    description,
    customerPrice,
    _id
  } = product;
  const classes = isFixed ? fixedClasses : responsiveClasses;
  const handleProductClick = () => {
    if (onClick) {
      onClick({
        _id: String(_id),
        name,
        image,
        price: customerPrice,
        quantity: 1
      });
    }
  };
  const handleQuantityChange = value => {
    if (onChange) {
      onChange(String(_id), value);
    }
  };
  const handleClickToInput = e => {
    e.stopPropagation();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.container, {
      [classes.notSelectable]: !ableToSelect,
      [classes.selected]: quantity > 0
    }),
    style: {
      outlineColor: color
    },
    "data-productId": product._id,
    onClick: handleProductClick
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.circle, {
      [classes.checked]: quantity > 0
    })
  }, /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/React.createElement("img", {
    alt: name,
    src: image
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.nameSection
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.name
  }, name), quantity > 0 ? /*#__PURE__*/React.createElement("div", {
    className: classes.input,
    onClick: handleClickToInput
  }, "Qty:\xA0", /*#__PURE__*/React.createElement(GoodieGiveawayProductQuantityInput, {
    onChange: handleQuantityChange,
    quantity: quantity
  })) : null), /*#__PURE__*/React.createElement(LinesEllipsis, {
    text: description,
    maxLine: "3",
    ellipsis: "...",
    trimRight: true,
    basedOn: "letters",
    className: classes.description
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.price
  }, /*#__PURE__*/React.createElement("p", null, "Price:"), /*#__PURE__*/React.createElement("p", null, Price.formatPrice(customerPrice)))));
};